import React from 'react';
import clsx from 'clsx';
import Collapse, { Panel } from 'rc-collapse';
import { withTranslation, WithTranslation } from 'react-i18next';
import QRcodeSelector from './QRcodeSelector';
import { TargetNode } from '../../models/TargetNode';


type ChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => void;

interface QrCodePanelOwnProps {
  node: TargetNode;
  title: string;
  onChangeTitle: ChangeHandler;
  // Stored and displayed without the protocol; the generator adds it via
  // `prefix` below.
  url: string;
  onChangeUrl: ChangeHandler;
  scale: number;
  // react-select types every select as clearable, so the parameter must admit
  // null even though this one is not.
  onChangeScale: (option: { value: number } | null) => void;
  // CSS-module class names, still owned by the container's stylesheet.
  selectorClassName?: string;
  buttonContainerClassName?: string;
  linkClassName?: string;
}

// The external generator. Both buttons hit the same service; the second variant
// renders the code without the surrounding texts.
const GENERATOR_URL = 'https://anna.palaute.info/index_qr.php';
const GENERATOR_URL_NO_TEXT = 'https://anna.palaute.info/index_qr_no_text.php';

const generatorHref = (base: string, scale: number, url: string, text: string) =>
  `${base}?scale=${scale}&url=${url}&prefix=https://&text=${text}`;

const QrCodePanel = ({
  node, title, onChangeTitle, url, onChangeUrl, scale, onChangeScale,
  selectorClassName, buttonContainerClassName, linkClassName, t,
}: QrCodePanelOwnProps & WithTranslation) => (
  <Collapse>
    <Panel header={t('target.editor.qrCode.title')} forceRender={true}>
      <i className="fa fa-exclamation-triangle" aria-hidden="true" style={{ color: "red" }}></i>
      <label style={{ color: "red" }}>  {t('target.editor.qrCode.warning')}</label>
      <div style={{ height: "0.4em" }}></div>

      <label>{t('target.editor.qrCode.title')}</label>
      <input id="qrcode-title" type="text" placeholder="Add title" data-redisid="qrcodetitle"
        value={title}
        onChange={onChangeTitle} />
      <div style={{ height: "0.4em" }}></div>

      <label>{t('target.editor.qrCode.URL')}</label>
      <input id="qrcode-url" type="text" placeholder="Add URL" data-redisid="qrcodeurl"
        value={url}
        onChange={onChangeUrl} />
      <div style={{ height: "0.4em" }}></div>

      <label>{t('target.editor.qrCode.scale')}</label>
      <QRcodeSelector
        className={selectorClassName}
        node={node}
        onChangeQRcode={onChangeScale} />

      {/* Reserves room for the scale dropdown to open inside the panel. */}
      <div id="qrcode--menu--separator" style={{ height: "15.0em" }}></div>

      <div className={buttonContainerClassName}>
        <a id="qrcode-button" className={clsx(linkClassName, 'button success target--link')}
          href={generatorHref(GENERATOR_URL, scale, url, title)}
          title="Create QR code with texts"
          target="_blank">
          <i className="fa fa-qrcode"></i> {t('target.editor.button.generate')}</a>

        <a id="qrcode-button-no-texts" className={clsx(linkClassName, 'button success target--link')}
          href={generatorHref(GENERATOR_URL_NO_TEXT, scale, url, title)}
          title="Create QR code without texts"
          target="_blank">
          <i className="fa fa-qrcode"></i> {t('target.editor.button.generateWithoutTexts')}</a>
      </div>
    </Panel>
  </Collapse>
);

export default withTranslation('common')(QrCodePanel);
